import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatMessage'
})
export class FormatMessagePipe implements PipeTransform {

    transform(value: unknown, ...args: unknown[]): unknown {
        if(window.localStorage.getItem('language') === 'en') {
            return `${value} format error`
        } else return `${value} 格式错误`
    }

}
